if (Shopify.derm_custom == undefined) Shopify.derm_custom = {};

Shopify.derm_custom.addToBagShopify = async function(evt, variantId, isBundle = false){

  var btn = document.querySelector('.atc_variant_button[data-variant-id="' + variantId + '"]');

  if (btn != undefined){
    try {
      if (btn.classList.contains('loading')) return;

      btn.classList.add('loading');
      btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var btnTimeout = setTimeout(function(){
        btn.classList.remove('loading');
        btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
      },5000)
    } catch(err) {
        console.error(err)
    }
  }

  return new Promise( async function(resolve,reject){

    try{

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const formData = {"items":[]};
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        if( isBundle ) {
          formData["items"].push({'id': variantId, 'quantity': 1, 'properties' :{'_is_bundle': true}});
        } else {
          formData["items"].push({id: variantId, quantity: 1});
        }
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
  
          var response_data = response.items[0];
          response_data.sections = response.sections;
  
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.cart.renderContents(response_data);

          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            if (btn != undefined){
                try{
                    btn.classList.remove('loading');
                    btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
                } catch(err){
                    console.error(err)
                }
            }

        })
        .catch((error) => {
          console.error('Error:', error);

            if (btn != undefined){
                try{
                    btn.classList.remove('loading');
                    btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
                } catch(err){
                    console.error(err)
                }
            }

        });

    }catch(err){
      reject(err);
    }
  })
}

Shopify.derm_custom.selectVariantInCarousel = async function(productID, variantID){

    // Update the selected variant border
    const variantChoices = document.querySelectorAll('.card-wrapper[data-product-id="' + productID + '"] .variant-choice');
    variantChoices.forEach((element) => {
        element.classList.remove('active');
    });

    document.querySelectorAll('.card-wrapper[data-product-id="' + productID + '"] .variant-choice[data-variant-id="' + variantID + '"]').forEach(function(productCard){
        productCard.classList.add('active');
    });

    // Update the selected variant add to cart button
    const buttonChoices = document.querySelectorAll('.card-wrapper[data-product-id="' + productID + '"] .atc_variant_button');
    buttonChoices.forEach((element) => {
        element.classList.remove('active');
    });

    document.querySelectorAll('.card-wrapper[data-product-id="' + productID + '"] .atc_variant_button[data-variant-id="' + variantID + '"]').forEach(function(productCard){
        productCard.classList.add('active');
    });

    // Update the selected variant iamge
    const imageChoices = document.querySelectorAll('.card-wrapper[data-product-id="' + productID + '"] .variant_image');
    imageChoices.forEach((element) => {
      element.classList.remove('active');
    });

  console.log('varrianr:' + variantID);

    document.querySelector('.card-wrapper[data-product-id="' + productID + '"] .variant_image[data-variant-id="' + variantID + '"]').classList.add('active');

    // Update the selected variant iamge
    const priceChoices = document.querySelectorAll('.card-wrapper[data-product-id="' + productID + '"] .plp_price_custom');
    priceChoices.forEach((element) => {
      element.classList.remove('active');
    });

    document.querySelector('.card-wrapper[data-product-id="' + productID + '"] .plp_price_custom[data-variant-id="' + variantID + '"]').classList.add('active');


}